import { QueryClient } from "@tanstack/react-query";
import { isNative } from "@/lib/capacitor";

/** Shared query cache so tenant-boundary transitions can purge it atomically. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchInterval: isNative ? false : 60 * 1000,
      refetchOnWindowFocus: isNative ? false : true,
      staleTime: isNative ? 2 * 60 * 1000 : 30 * 1000,
      gcTime: 30 * 60 * 1000,
      retry: isNative ? 1 : 2,
      refetchOnMount: true,
    },
  },
});